import { GeckoMeasurement, GeckoMeasurementUnit } from 'types'

/**
 * FCA = corrosion rate × elapsed years, returned in millimeters.
 * Forces the rate into mm/yr first so the result is genuinely mm regardless of
 * the rate's display unit (mm/yr vs in/yr). See toNumber() in geckoMeasurement.ts.
 */
export function computeFca(
  corrosionRate: GeckoMeasurement,
  years: number
): GeckoMeasurement {
  const ratePerYearMm = corrosionRate.toNumber(
    GeckoMeasurementUnit.MillimetersPerYear
  )
  return GeckoMeasurement.CreateFromValue(
    ratePerYearMm * years,
    GeckoMeasurementUnit.Millimeters
  )
}
